import { html, type Html, Page } from 'rune-ts';
import klass from './AdResFinish.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { footer_links } from '../../components/cells/Footer/constant';
import { getResizedUrl } from '../../../shared/util/image';
import { font } from '@services/MarppleShop/shared/typography';

export type AdResFinishPageData = {
  layout_options: BaseLayoutOptions;
  email: string;
};

export class AdResFinishPage extends Page<AdResFinishPageData> {
  protected override template({ layout_options, email }: AdResFinishPageData): Html {
    const { is_mobile } = layout_options;
    const texts = {
      title: html.preventEscape(ET(`mps2::ad_res::finish_title${is_mobile ? '_mo' : ''}`)),
      description_1: ET('mps2::ad_res::finish_description_1'),
      description_2: html.preventEscape(ET('mps2::ad_res::finish_description_2')),
      info_desc: html.preventEscape(ET(`mps2::ad_res::finish_info_desc${is_mobile ? '_mo' : ''}`)),
    };
    const body = html`
      <div class="${klass.page}">
        <div class="${klass.container}">
          <div class="${klass.image_wrapper}">
            <img
              class="${klass.image}"
              src="${getResizedUrl({
                url: '//s3.marpple.co/files/u_4648126/2024/10/original/42b8927f0d6d4d19e6f6a696a7a5e57afaa64df01.png',
                width: 200 * 2,
                quality: 85,
              })}"
              alt="MarppleShop creator apply finish image"
            />
          </div>
          <div class="${klass.title} ${font('24_bold', '20_bold')}">${texts.title}</div>
          <div class="${klass.email} ${font('20_bold', '16_bold')}">${email}</div>
          <div class="${klass.content}">
            <div class="${font('16_medium', '14_medium')}">${texts.description_1}</div>
            <div class="${font('16_medium', '14_medium')}">${texts.description_2}</div>
          </div>
          <div class="${klass.info} ${font('14_medium', '12_medium')}">${texts.info_desc}</div>
        </div>
      </div>
    `;

    return html`
      <div>
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: false,
            full_width: true,
            has_bottom_tab_bar: false,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
